import { Mic } from "react-feather";
import { Input } from "reactstrap";
import { Href, NameAndPhoneNumber } from "../../../../../../constants";
import { Link } from "react-router-dom";
import { ContactEdit } from "../../ContactEdit";
import { Fragment } from "react";
import { dynamicImage } from "../../../../../../utils";
import { ContactWrapperData } from "../../../../../../data/applications/Chat";
import SvgIcon from "../../../../../../coreComponents/SvgIcon";
import { Image } from "../../../../../../coreComponents/Image";

// This component displays a list of contacts with a search bar and an option to add new contacts.
export const ContactTabs = () => {
  return (
    <>
      <div className="common-space">
        <p>{`Contacts`}</p>
        <div className="header-top">
          <Link className="btn badge-light-primary f-w-500" to={Href}>
            <i className="fa fa-plus" />
          </Link>
        </div>
      </div>
      <div className="search-contacts">
        <Input type="text" placeholder={NameAndPhoneNumber} />
        <SvgIcon iconId="stroke-search" />
        <Mic className="mic-search" />
      </div>
      <div className="contact-wrapper custom-scrollbar">
        {/* Mapping through ContactWrapperData to display dynamic list of contacts */}
        {ContactWrapperData.map((data, index) => (
          <Fragment key={index}>
            <p>{data.mainLetter}</p>
            {data.contactData.map((item, i) => (
              <ul className="border-0" key={i}>
                <li className="common-space">
                  <div className="chat-time">
                    {item.image && <Image className="img-fluid rounded-circle" src={dynamicImage(`${item.image}`)} alt="user" />}
                    {item.imageUser && (
                      <div className={`custom-name bg-light-${item.color}`}>
                        <p className={`txt-${item.color} f-w-500`}>{item.imageUser}</p>
                      </div>
                    )}
                    <div>
                      <span>{item.name}</span>
                      <p>{item.phoneNumber}</p>
                    </div>
                  </div>
                  <ContactEdit />
                </li>
              </ul>
            ))}
          </Fragment>
        ))}
      </div>
    </>
  );
};
